import { css } from '@emotion/react';
import { Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { Segment } from './parse-formatted-text';

const styles = {
  'segment-type': {
    plain: css``,
    highlight: ({ theme }) => css`
      background-color: ${theme.colors.primary.fuchsia[10]};
    `,
  },
} satisfies Styles<void, { 'segment-type': Segment['type'] }>;

export const useStyles = withStyles(styles);
